import React, { Component } from "react";
import { ModalFooter } from "@atlaskit/modal-dialog";
import Spinner from "@atlaskit/spinner";
import Button from "@atlaskit/button";
import { ct } from "../constant-Utils";

class Footer extends Component {
  render() {
    const {
      onClose,
      showKeyline,
      text,
      onSubmit,
      isLoading,
      isHide,
      className,
    } = this.props;

    if (isHide) {
      return (
        <ModalFooter showKeyline={showKeyline} className={className || ""}>
          <Button
            id="close-modal"
            appearance="subtle"
            className="cancel-button"
            onClick={onClose}
          >
            {ct("Translate.buttonTitle.closeSmall")}
          </Button>
        </ModalFooter>
      );
    }

    // the focus should be on the subtle button, but it isn't
    return (
      <ModalFooter showKeyline={showKeyline} className={className || ""}>
        {!isLoading ? (
          //  <Button className="submit-button join-meeting-pass" onClick={ onSubmit }>
          <Button
            className="submit-button join-meeting-pass pull-right"
            id="create-room"
            onClick={onSubmit}
          >
            {text}
          </Button>
        ) : (
          // <Button className="submit-button join-meeting-pass" ><Spinner size="small" /> </Button>
          <Button
            className="submit-button join-meeting-pass pull-right align-items-center"
            id="create-room-spinner"
          >
            <Spinner size="small" />{" "}
          </Button>
        )}
        {onClose && (
          <Button
            appearance="subtle"
            className="cancel-button"
            id="close-create-room-modal"
            onClick={onClose}
          >
            {ct("Translate.buttonTitle.closeSmall")}
          </Button>
        )}
      </ModalFooter>
    );
  }
}

export default Footer;
